import React from 'react';
import ReactDOM from 'react-dom/client';

// project imports
import App from './app/App';

// style + assets
import 'assets/scss/style.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
